import { useState } from "react";
import Layout from "../layout/Layout";
import { RouteComponentProps } from "@reach/router";
import { EntityNames } from "../../../enums/EntityNames";
import EntityView from "../layout/EntityView/EntityView";

export default function OperatorSettingsPage() {

    return (
        <Layout pageTitle="Settings" showBackButton={false} showBreadcrumb={false} canScroll={false}>
            <EntityView entityName={EntityNames.operatorSettings} entityId={undefined} />
        </Layout>
    )
}


